<template>
  <div class="profile-page first_page" >
    <loading-block v-if="isload==false" :loading="!isload"/>
    <section class="section" v-if="isload">
      <div class="container-fluid">
        <div class="col-12 col-md-6 col-lg-5">
          <UserCard   :user="developer" />
        </div>
        <div class="row mt-3 ml-3 mb-3">
          <router-link tag="a" v-if="count_works>0" class="btn" :to="{name: 'developer', params: { username: this.developer.username }}">Все работы
          </router-link>
          <router-link tag="a" v-if="count_reviews>0" class="btn btn-active" :to="{name: 'reviewpage', params: { username: this.developer.username }}">Отзывы
          </router-link>
          <router-link tag="a" class="btn" v-if="developer.isshop && developer.isshop==1 && developer.shop_setting.status && developer.shop_setting.status=='on' && count_items>0" :to="{name: 'developer_catalog', params: { username: this.developer.username }}">Каталог</router-link>
        </div>
        <div class="row">
          <div class="row m-3   developer_block_review section_gray_bg" v-if="developer.reviews.length>0" v-for="(review,review_index) in developer.reviews">
            <div class="col-4 col-md-2 block_avatar">
              <img :src="image_url+review.who.avatar" class="mt-2 img img-thumbnail" v-if="review.who.avatar" >

              <div class="avatar" v-if="review.who.avatar==null">

                <avatar v-if="review.who.avatar==null" :size="35" :username="review.who.name"
                        class="rounded-circle"></avatar>

              </div>
            </div>
            <div class="col-8  review_data">
              <h3 class="client_name">{{ review.who.name }}</h3>
              <sui-rating :rating="parseInt(review.rating)" :max-rating="5"/>
              <p>{{ review.review }}</p>
              <p>{{ review.created_at }}</p>
            </div>





          </div>

        </div>
      </div>
    </section>


  </div>
</template>
<script>
import {eventBus} from "@/main";
import Vue from "vue";
import Api from "@/models/Api";
import Editorjsrender from "@/models/Editorjsrender.vue";
import UserCard   from "@/components/Custom/UserCard.vue";
import LoadingBlock from "@/components/Custom/LoadingBlock";
var Avatar = require('vue-avatar')

export default {
  name: "developer",
  data() {
    return {
      'more_btn': '<button  class="btn">Посмотреть работу</button>',
      "isload": false,
      'developer': {},
      'work': {},
      'image_url': null,
      'count_reviews':0,
      'count_works':0,
      'count_items':0,

    }
  },
  mounted() {
    var app = this;
    Api.loadDeveloperReviews(this.$route.params.username, function (developer_data) {
      app.image_url = Vue.config.IMAGE_URL;
      app.developer = developer_data.developer;
      app.count_reviews=developer_data.count_reviews;
      app.count_works=developer_data.count_works;
      app.count_items=developer_data.count_items;


      app.isload = true;
    });


  },
  methods: {},
  components: {
    'UserCard':UserCard,
    'editorjsrender': Editorjsrender, 'avatar': Avatar.Avatar,
    LoadingBlock
  }
};
</script>
<style>
</style>
